/*
 * Code generated by maegi. DO NOT EDIT.
 */

import type React from "react";

export const Close16 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="square"
      strokeWidth={2}
      d="m2.706 2.705 10.588 10.58m-10.588.01 10.588-10.58"
    />
  </svg>
);

export const __descriptor_Close = {
  name: "Close",
  instances: [{ size: 16, Component: Close16 }],
} as const;
